
import React from 'react';

const TermsContent_es: React.FC = () => (
    <div className="space-y-4 text-sm leading-relaxed text-slate-700" dir="ltr">
        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">1. Propiedad de Recetas y Atribución</h3>
            <p>
                Al publicar contenido en mealPai, usted reconoce y acepta que cualquier receta agregada de una fuente externa (incluyendo, entre otros, sitios web, libros de cocina o blogs) que sea idéntica o sustancialmente similar a la fuente original <strong>debe incluir un enlace de referencia directo (URL) o cita</strong> al creador original si la receta está marcada como "Pública".
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">2. Responsabilidad del Usuario y Obligación</h3>
            <p>
                Las recetas públicas que se copian de una fuente externa sin el crédito o referencia adecuada pueden constituir una violación de los derechos de propiedad intelectual.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                    <strong>Responsabilidad del Usuario:</strong> El usuario que publica el contenido es el único responsable de garantizar que tiene derecho a compartir el contenido y de proporcionar la atribución necesaria.
                </li>
                <li>
                    <strong>Limitación de Responsabilidad:</strong> mealPai, sus operadores, empleados, voluntarios y afiliados (remunerados o no) <strong>no serán responsables</strong> de las recetas copiadas, publicadas o distribuidas por los usuarios sin el crédito adecuado o en violación de las leyes de derechos de autor.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">3. Modificaciones y Uso Justo</h3>
            <p>
                Se anima a los usuarios a sugerir cambios, adaptaciones o mejoras a las recetas. Sin embargo, dichas sugerencias y modificaciones publicadas deben permanecer dentro de los límites de las leyes de derechos de autor aplicables. La transformación sustancial de una receta no niega automáticamente el requisito de atribución si el trabajo principal se deriva de una fuente protegida.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">4. Contenido y Conducta Prohibidos</h3>
            <p>
                Está estrictamente prohibido que los usuarios publiquen contenido que incluya lenguaje soez, ofensivo, racista, brutal, discurso de odio u otro lenguaje inapropiado.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                    <strong>Tolerancia Cero:</strong> mealPai mantiene una política de tolerancia cero hacia el acoso, el discurso de odio y el contenido ofensivo.
                </li>
                <li>
                    <strong>Desactivación de Cuenta:</strong> Cualquier usuario que sea responsable de publicar dicho contenido será personalmente responsable. mealPai reserva el derecho de <strong>desactivar inmediatamente la cuenta</strong> de cualquier usuario que viole esta política, sin previo aviso.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">5. Eliminación de Contenido</h3>
            <p>
                mealPai se reserva el derecho, pero no asume la obligación, de eliminar cualquier contenido que se reporte o descubra que viola estos términos o las leyes de propiedad intelectual aplicables, sin previo aviso al usuario.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">6. Precios y Suscripciones</h3>
            <p>
                Actualmente, mealPai se ofrece de forma gratuita para pruebas y uso personal. Sin embargo, nos reservamos el derecho de introducir planes de suscripción de pago o tarifas de servicio en el futuro. El acceso a ciertas funciones premium o límites de uso superiores puede requerir una suscripción paga. Los usuarios serán notificados con antelación de cualquier cambio obligatorio en el modelo de precios.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">7. Persistencia y Pérdida de Datos</h3>
            <p>
                Si bien realizamos esfuerzos razonables para mantener la seguridad e integridad de sus datos, mealPai se proporciona "tal cual" y "según disponibilidad". <strong>Renunciamos expresamente a cualquier responsabilidad por la pérdida de datos</strong> (incluidas recetas, planes de comidas o historial de cuenta) que ocurra con el tiempo debido a errores técnicos, migraciones del sistema, fallos de la base de datos o eliminación de la cuenta.
            </p>
            <p className="mt-2">
                Se recomienda encarecidamente a los usuarios que utilicen periódicamente la función <strong>"Exportar datos"</strong> disponible en el menú para mantener copias de seguridad personales de su información.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">8. Uso de inteligencia artificial (IA) y descargo de responsabilidad</h3>
            <p>
                La aplicación (mealPai) utiliza tecnologías de inteligencia artificial (IA) para el análisis de recetas, la extracción de ingredientes, las advertencias de alergias y el análisis de comidas adaptado al usuario. Tenga en cuenta que esta tecnología no es inmune a errores y puede generar ocasionalmente información incorrecta, incompleta o imprecisa.
            </p>
            <p className="mt-2">
                Todo el contenido generado por IA se proporciona como recomendación y únicamente con fines informativos. Los usuarios deben actuar con cautela y emplear su propio criterio independiente. Es responsabilidad exclusiva del usuario revisar y verificar manualmente todos los ingredientes y las advertencias de alergias (especialmente en casos de alergias graves o restricciones dietéticas estrictas) antes de preparar o consumir cualquier alimento. La confianza en esta información es estrictamente bajo el propio riesgo del usuario.
            </p>
        </section>
    </div>
);

export default TermsContent_es;
